export default __webpack_public_path__ + "static/media/ag-icon.31fd42ff.webp";